import { render, staticRenderFns } from "./PageBase.vue?vue&type=template&id=859c23d6"
import script from "./PageBase.vue?vue&type=script&lang=js"
export * from "./PageBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports